import React, {Fragment} from 'react';

import '../../App.css';
import {Avatar, Button, Flex, Space} from "antd";
import Title from "antd/es/typography/Title";
import project from "./Project";
import {useNavigate} from "react-router-dom";

const ProjectNotFound = () => {
    const navigate = useNavigate()
    return (
        <Flex vertical={true} justify={'center'} align={'center'} gap={20}>
            <img src={'/images/404.png'} width={500} height={500}/>
            <Title level={5}>Requested project doesn't exist or you don't have access to it.</Title>
            You can ask the project owner to invite you to the project.
            <Space>
                <Button
                    type={'default'}
                    onClick={() => {
                        navigate("/")
                    }}
                >Back to Projects</Button>
            </Space>
        </Flex>
    )
}

export default ProjectNotFound;